// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u1pof{padding:16px 16px 16px 36px;border-bottom:1px solid rgba(2,6,12,.1)}`, "",{"version":3,"sources":["webpack://./src/components/CitySearch/CitySearch.module.scss"],"names":[],"mappings":"AAAA,OACI,2BAAA,CACA,uCAAA","sourcesContent":[".option {\n    padding: 16px 16px 16px 36px;\n    border-bottom: 1px solid rgba(2, 6, 12, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"option": `u1pof`
};
export default ___CSS_LOADER_EXPORT___;
